import positionProperties from '../constants/position-properties';
import { DESKTOP_BREAKPOINT } from '../constants/breakpoints';
import getCompositeItemPosition from './get-composite-item-position';

const getPositionValues = (element, breakpoint = DESKTOP_BREAKPOINT) => {
  const x = element.style.getPropertyValue(positionProperties.X);
  const y = element.style.getPropertyValue(positionProperties.Y);

  // The inline properties are a drag transient (§ regeneration barrier) — while present
  // they are the live value, ahead of whatever the persisted class/attribute says.
  // A partial pair (one axis only) still wins for that axis; the other falls back
  // to the class cascade so a single-axis drag never loses its committed sibling.
  if (x || y) {
    const fallback = x && y ? null : getCompositeItemPosition({ element, breakpoint });

    return {
      x: x ? parseFloat(x) : fallback.x,
      y: y ? parseFloat(y) : fallback.y,
    };
  }

  return getCompositeItemPosition({ element, breakpoint });
};

export default getPositionValues;
